<template>
  <div class="h-screen flex flex-col text-gray-800">
    <nav v-if="loggedIn" class="col-span-2 bg-blue-400 p-6">
      <div class="flex justify-between">
        <base-loading v-if="fetchingCompanyLogo" class="h-8" />
        <router-link v-else to="/" class="block text-xl font-bold h-8">
          <img
            v-if="currentCompany.image"
            :src="
              `https://linkmanager-stage.datacroft.de${currentCompany.image}?cache=${cacheBuster}`
            "
            alt=""
            class="max-h-full"
          />
          <span v-else>{{ currentCompany.name }}</span>
        </router-link>
        <div class="text-right">
          <router-link
            :to="{ name: 'my-account' }"
            class="font-bold inline-block mr-8 text-black border-b-2 border-transparent hover:border-blue-400"
            active-class="border-white"
          >
            My account
          </router-link>
          <button
            @click="$store.dispatch('auth/logout')"
            class="inline-block text-black border-b-2 border-transparent hover:border-blue-400"
          >
            Log out
          </button>
        </div>
      </div>
    </nav>

    <div class="flex flex-1 overflow-hidden">
      <app-nav-side v-if="loggedIn && !noCompanies" />

      <main class="flex-1 overflow-y-scroll">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AppNavSide from './components/AppNavSide';

export default {
  components: {
    AppNavSide,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      cacheBuster: (state) => state.company.cacheBuster,
      fetchingCompanyLogo: (state) =>
        state.company.fetchingList || state.company.changingCompany,
    }),
    ...mapGetters('company', ['currentCompany', 'noCompanies']),
  },
};
</script>
